// Brand images generated from the delivered logo by scripts/build-brand-assets.py.
// The icons and the link preview are published under stable names by the build
// (scripts/generate-seo-pages.cjs), not imported here.
import logo from './paioneer-logo-web.png';
import wordmark from './paioneer-wordmark.png';

export const brandImages = {
  logo,
  wordmark
};
